import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UpdateUserSupportingCompanyOpts, UserSupportingCompany } from '@interfaces';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class UserSupportingCompanyHttpService {
  private readonly http = inject(HttpClient);

  private API_URL = environment.API_URL;

  public getCompaniesSupportedByUser(userId: String): Observable<UserSupportingCompany[]> {
    const url = `${this.API_URL}/user-supporting-companies/user/${userId}`;
    return this.http.get<UserSupportingCompany[]>(url);
  }

  public getUsersSupportingCompany(companyId: String): Observable<UserSupportingCompany[]> {
    const url = `${this.API_URL}/user-supporting-companies/company/${companyId}`;
    return this.http.get<UserSupportingCompany[]>(url);
  }

  public updateSupportingCompanyOfUser(payload: UpdateUserSupportingCompanyOpts): Observable<UserSupportingCompany> {
    const url = `${this.API_URL}/user-supporting-companies`;
    return this.http.patch<UserSupportingCompany>(url, payload);
  }
}
